import React from 'react';
import {Stack, useTheme} from '@mui/material';
import type {FCWithChildren} from 'types';

type Props = {
  horizontal?: boolean;
  tight?: boolean;
};

export const FieldLayout: FCWithChildren<Props> = ({
  horizontal = false,
  tight = false,
  children,
}) => {
  const {colors} = useTheme();
  return (
    <Stack
      direction={horizontal ? 'row' : 'column'}
      spacing={tight ? 0 : 2}
      sx={{
        color: colors.burgundy,
        flex: horizontal ? '1' : undefined,
      }}>
      {children}
    </Stack>
  );
};
